var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    {
      staticClass: "bg-secondary full-height",
      staticStyle: { "min-height": "200px" }
    },
    [
      _c("q-card-main", { staticClass: "text-white" }, [
        _c("div", { staticClass: "row gutter-md" }, [
          _c(
            "div",
            { staticClass: "col-5 text-center" },
            [
              _c("q-icon", { attrs: { size: "5rem", name: _vm.icon } }),
              _c("p", { staticClass: "q-pt-sm module-names" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.getModuleTitle(_vm.module_type)) +
                    "\n                "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "col-7" }, [
            _c("div", { staticClass: "row" }, [
              _vm.active != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.active_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: { endVal: _vm.active, options: _vm.options }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.inactive != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.inactive_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: { endVal: _vm.inactive, options: _vm.options }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.deleted != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.deleted_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: { endVal: _vm.deleted, options: _vm.options }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.pre_registered != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.self_registered_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: {
                            endVal: _vm.self_registered,
                            options: _vm.options
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.pre_registered != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.pre_registered_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: {
                            endVal: _vm.pre_registered,
                            options: _vm.options
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.others != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.others_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: { endVal: _vm.others, options: _vm.options }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.certificates != null
                ? _c("div", { staticClass: "col-12 q-mb-sm" }, [
                    _c(
                      "div",
                      { staticClass: "iCountUp" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.certificates_lb) +
                            " "
                        ),
                        _c("ICountUp", {
                          attrs: {
                            endVal: _vm.certificates,
                            options: _vm.options
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }